import FlexContainerBase from './_flex-container-base.js'
import ConfigurablePane from './_configurable-pane.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurablePosition from './_configurable-position.js'
import ConfigurableTransition from './_configurable-transition.js'
import FlexPane from './_flex-pane.js'
import Button from './_button.js'
import Image from './_image.js'
import Text from './_text.js'
import ImageButton from './_image-button.js'

export default {
  name: 'ToastView',
  values: {
    showTimeout: '3.5s',
    messageKey: '',
    titleKey: '',
    style: {
      motionContainer: {
        position: 'absolute',
        top: '-100%',
        width: '100%',
        height: 'auto',
        transitionProperty: 'top',
        transitionDuration: '0.5s',
        transform: undefined,
        $mixin: [
          {
            configSet: FlexContainerBase,
          },
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
          {
            configSet: ConfigurablePosition,
          },
          {
            configSet: ConfigurableTransition,
          },
        ],
      },
      transition: {
        top: 0,
        transform: undefined,
        $mixin: [
          {
            configSet: ConfigurableTransition,
          },
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
          {
            configSet: ConfigurablePosition,
          },
        ],
      },
    },
    container: {
      configSet: FlexPane,
      configValues: {
        createStackingContext: true,
        style: {
          minWidth: '324px',
          minHeight: '40px',
        },
      },
    },
    clickableArea: {
      configSet: Button,
      configValues: {
        style: {
          base: {
            flexGrow: '1',
            minHeight: '40px',
            maxHeight: '40px',
            padding: '0 0 0 8px',
            alignItems: 'center',
          },
        },
      },
    },
    icon: {
      configSet: Image,
      configValues: {
        style: {
          minWidth: '24px',
          minHeight: '24px',
        },
      },
    },
    messageContainer: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexDirection: 'column',
          padding: '0 0 0 8px',
          justifyContent: 'center',
        },
      },
    },
    title: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    message: {
      configSet: Text,
      configValues: {
        container: {
          flexGrow: 0,
        },
      },
    },
    closeButton: {
      configSet: ImageButton,
      configValues: {
        button: {
          style: {
            base: {
              alignItems: 'center',
              flexGrow: '0',
              flexBasis: '40px',
              maxHeight: '40px',
            },
          },
        },
        buttonIcon: {
          src: 'close',
          style: {
            minWidth: '9px',
            minHeight: '9px',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
